import * as fecha from "fecha";
import { parse } from "fecha";
import HotelDatepicker from "hotel-datepicker";
import "hotel-datepicker/dist/css/hotel-datepicker.css";

export function searchAvailableDates() {
  let arrivalDeparture = document.getElementById("search-checkin-checkout");
  let startDate = document.getElementById("search_start_date");
  let departDate = document.getElementById("search_end_date");
  let endTurnDates = strToArray(departDate.getAttribute("data-turndates"));
  let checkInDays = startDate.getAttribute("data-checkin-days");

  let startTurnDates = strToArray(
    arrivalDeparture.getAttribute("data-turndates")
  );
  let minStay = arrivalDeparture.getAttribute("data-min-stay");

  let params = new URLSearchParams(window.location.search);

  let datePicker = new HotelDatepicker(arrivalDeparture, {
    inline: false,
    clearButton: false,
    format: "ddd MM/DD/YYYY",
    onSelectRange: function () {
      let regex =
        /[A-za-z]{3} ([0-9]{1,2}\/[0-9]{1,2}\/[0-9]{2,4}) - [A-za-z]{3} ([0-9]{1,2}\/[0-9]{1,2}\/[0-9]{2,4})/;
      let dates = arrivalDeparture.value.match(regex);
      console.log("Closed!", dates, arrivalDeparture.value);
      if (document.getElementById("search_start_date"))
        document.getElementById("search_start_date").value = dates[1];
      if (document.getElementById("search_end_date"))
        document.getElementById("search_end_date").value = dates[2];
    },
  });
  //datePicker.setDates(d1, d2);
  //   datePicker.addEventListener(
  //     "afterClose",
  //     function () {
  //       console.log("Closed!", arrivalDeparture.value);
  //     },
  //     false
  //   );
}

function strToArray($string) {
  if (-1 == $string.indexOf(",")) {
    return [].push($string);
  }
  return $string.split(",");
}
